import { Markdown } from '../../about/Markdown'
import { Overlay } from '../../about/Overlay'
import { useOverlayStore } from '../../about/overlayStore'
import { useStrings } from '../../i18n'
import { VOLTAGE_METHODOLOGY, VOLTAGE_METHODOLOGY_PATH } from './methodologyDoc'

/**
 * `docs/voltage.md`, rendered where a derived badge can reach it in one click.
 *
 * The content is not written here and never will be: a parallel task owns the
 * prose, and this modal renders whatever is on disk. Until that file lands, the
 * placeholder says so plainly instead of inventing a methodology - a page that
 * made up its own rules would defeat the point of having the badge link here.
 */
export const MethodologyModal = () => {
  const strings = useStrings()
  const close = useOverlayStore((state) => state.close)

  return (
    <Overlay title={strings.voltage.methodologyTitle} onClose={close}>
      {VOLTAGE_METHODOLOGY === null ? (
        <div className="ev-doc-missing">
          <p>{strings.voltage.methodologyMissing}</p>
          <p className="ev-doc-missing__path">
            <code>{VOLTAGE_METHODOLOGY_PATH}</code>
          </p>
          <p>{strings.voltage.unknownExplanation}</p>
        </div>
      ) : (
        <Markdown source={VOLTAGE_METHODOLOGY} />
      )}
    </Overlay>
  )
}
